export const getTimezone = (): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";
  const abs = Math.abs(offsetMinutes);
  const hours = Math.floor(abs / 60);
  const minutes = abs % 60;
  const offset =
    minutes > 0
      ? `GMT${sign}${hours}:${String(minutes).padStart(2, "0")}`
      : `GMT${sign}${hours}`;
  return `${timeZone} (${offset})`;
};

export const getAcceptLanguage = (): string => {
  const langs = navigator.languages;
  if (!langs || langs.length === 0) return navigator.language || "en";
  return langs
    .map((lang, i) =>
      i === 0 ? lang : `${lang};q=${Math.max(1 - i * 0.1, 0.1).toFixed(1)}`,
    )
    .join(",");
};
